export enum EProfileOrigin {
    PEOPLE,
    SEARCH,
}
